import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const PrivatePresentationCTA = ({ variant = "default" }) => {
  const { t } = useLang();
  return (
    <section
      data-testid="cta-private-presentation"
      className="relative overflow-hidden bg-[hsl(var(--md-bone))] border-y border-[hsl(var(--md-line))]"
    >
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative max-w-[1480px] mx-auto px-6 md:px-12 lg:px-16 py-28 md:py-40">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-7 md:col-start-2">
            <p className="font-eyebrow text-[hsl(var(--md-stone))] mb-8">
              {t.cta.eyebrow}
            </p>
            <h2 className="display-1 text-[hsl(var(--md-ink))] mb-8">
              {variant === "contact" ? t.cta.titleContact : t.cta.titleDefault}
            </h2>
            <p className="editorial text-[hsl(var(--md-stone))] max-w-[58ch]">
              {t.cta.body}
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-9 flex md:items-end">
            <Link
              to="/contact"
              data-testid="cta-request-presentation"
              className="btn-ghost group"
            >
              {t.cta.button}
              <ArrowUpRight
                size={16}
                strokeWidth={1}
                className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
